// Environment configuration for the frontend
export const config = {
    // API URLs - fallback to localhost for development
    api: {
        auth: import.meta.env.VITE_AUTH_API_URL || 'http://localhost:5001',
        staff: import.meta.env.VITE_STAFF_API_URL || 'http://localhost:5002',
        client: import.meta.env.VITE_CLIENT_API_URL || 'http://localhost:5004',
        roster: import.meta.env.VITE_ROSTER_API_URL || 'http://localhost:5005',
        billing: import.meta.env.VITE_BILLING_API_URL || 'http://localhost:5006',
        gateway: import.meta.env.VITE_GATEWAY_URL || 'http://localhost:5003'
    },
    
    // Environment info
    environment: import.meta.env.MODE || 'development',
    isDevelopment: import.meta.env.DEV || false,
    isProduction: import.meta.env.PROD || false,
    
    // App info
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    title: import.meta.env.VITE_APP_TITLE || 'Care Management System'
};

// Type-safe environment variables
declare global {
    interface ImportMetaEnv {
        readonly VITE_AUTH_API_URL?: string;
        readonly VITE_STAFF_API_URL?: string;
        readonly VITE_CLIENT_API_URL?: string;
        readonly VITE_ROSTER_API_URL?: string;
        readonly VITE_BILLING_API_URL?: string;
        readonly VITE_GATEWAY_URL?: string;
        readonly VITE_APP_VERSION?: string;
        readonly VITE_APP_TITLE?: string;
    }
}

export default config;
